import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseGridFilter, WithSubscription } from '@shared/base';
import { ColumnOptionsFilter, OptionFilterItem } from '@shared/models/grid-column.model';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Component({
  selector: 'gcc-grid-options-filter',
  templateUrl: './grid-options-filter.component.html',
  styleUrls: ['./grid-options-filter.component.scss'],
  standalone: false
})
export class GridOptionsFilterComponent
  extends WithSubscription(BaseGridFilter)
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('searchInput') public searchInput: ElementRef<HTMLInputElement>;
  // @ts-ignore
  @Input() get value(): string[] {
    return this.selectedValue;
  }
  set value(value: string[]) {
    this.selectedValue = [...value];
  }
  @Input() public config: ColumnOptionsFilter;

  public searchText = '';
  public options: OptionFilterItem[];

  private selectedValue = [];
  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.options = this.config?.options;
  }

  public ngAfterViewInit() {
    if (this.config?.allowSearch) {
      this.subs.add(
        fromEvent(this.searchInput.nativeElement, 'input')
          .pipe(
            debounceTime(300),
            map((e: KeyboardEvent) => {
              this.searchText = (e.target as HTMLInputElement).value;
              return this.searchText;
            })
          )
          .subscribe(search => {
            this.options = this.config?.options.filter(
              opt => opt.text.toLowerCase().indexOf(search.toLowerCase()) > -1
            );
          })
      );
    }
  }

  public trackByValue(_, opt: OptionFilterItem) {
    return opt.value;
  }

  public onClear() {
    this.searchInput.nativeElement.value = '';
    this.searchText = '';
    this.options = this.config.options;
  }

  public isOptionSelected(opt: OptionFilterItem) {
    return this.selectedValue.indexOf(opt.value) > -1;
  }

  public onOptionToggle(opt: OptionFilterItem) {
    const index = this.selectedValue.indexOf(opt.value);
    if (index > -1) {
      this.selectedValue.splice(index, 1);
    } else {
      this.selectedValue.push(opt.value);
    }
    this.onChange(this.selectedValue);
  }

  public onOptionsToggle() {
    if (this.selectedValue.length === this.config.options.length) {
      this.selectedValue.length = 0;
    } else {
      this.selectedValue = this.config.options.map(i => i.value);
    }
    this.onChange(this.selectedValue);
  }

  public onChange(value) {
    this.valueChange.emit(value);
  }
}
